var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isShow
        ? _c(
            "div",
            {
              staticClass: "mask",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.reset.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "goods-pop-wrap goods-visible" }, [
                _vm.background
                  ? _c("div", { staticClass: "goods-pop-background" }, [
                      _c("img", { attrs: { src: _vm.background } }),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "pop-header" }, [
                  _c("h2", { staticClass: "con-title" }, [
                    _vm._v("恭喜获得新物品"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "close-btn", on: { click: _vm.reset } },
                    [_c("i", { staticClass: "el-icon-close" })]
                  ),
                ]),
                _vm.case_info.isEnableAccumulateCase
                  ? _c(
                      "div",
                      {
                        staticClass: "con-gameInstanceBox",
                        class: _vm.gameInstance_info.isGameInstanceOpen
                          ? "con-gameInstanceBox-active"
                          : "",
                        on: { click: _vm.onGameInstanceBox },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "box-preview-wrap" },
                          [
                            _c(
                              "el-image",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "con-gameInstanceBox-casePic",
                                    class: _vm.gameInstance_info
                                      .isGameInstanceOpen
                                      ? "con-gameInstanceBox-casePic-open"
                                      : "",
                                    attrs: {
                                      src: _vm._f("imgfilter")(
                                        _vm.gameInstance_info.casePic
                                      ),
                                      fit: "cover",
                                    },
                                  },
                                  "el-image",
                                  _vm.$attrs,
                                  false
                                ),
                                _vm.$listeners
                              )
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "box-info" }, [
                          _c("p", { staticClass: "box-name" }, [
                            _vm._v(_vm._s(_vm.gameInstance_info.caseName)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "con-gameInstanceBox-btn" },
                            [
                              _vm.gameInstance_info.isGameInstanceOpen
                                ? _c("div", { staticClass: "open-case-btn" }, [
                                    _vm._v(" 立即开启 "),
                                  ])
                                : _vm._e(),
                              !_vm.gameInstance_info.isGameInstanceOpen
                                ? _c(
                                    "div",
                                    { staticClass: "open-case-progress" },
                                    [
                                      _vm._v(
                                        " 进度 " +
                                          _vm._s(
                                            _vm.case_info
                                              .accumulateCaseRoundCount
                                          ) +
                                          "/" +
                                          _vm._s(
                                            _vm.case_info.accumulateCaseRate
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "send-goods-bd" }, [
                  _c(
                    "div",
                    { staticClass: "send-goods-list" },
                    _vm._l(_vm.case_opened_awards, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "item-wrap" },
                        [
                          !item.isConvert
                            ? _c(
                                "div",
                                {
                                  staticClass: "list-item",
                                  class: "rarity-" + item.rarity,
                                },
                                [
                                  _c("span", { staticClass: "card-price" }, [
                                    _vm._v("￥" + _vm._s(item.price)),
                                  ]),
                                  _c("c-award", {
                                    staticClass: "c-award",
                                    attrs: {
                                      rarity: item.rarity,
                                      picture: item.itempic,
                                      name: item.name,
                                      price: item.price,
                                    },
                                  }),
                                  _c("div", { staticClass: "item-meta" }, [
                                    item.roll && !_vm.isAutoConverted
                                      ? _c("p", { staticClass: "roll-point" }, [
                                          _vm._v("Roll " + _vm._s(item.roll)),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  !_vm.isAutoConverted
                                    ? _c(
                                        "div",
                                        { staticClass: "card-actions" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn-action sell",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.case_opened_awards_discount(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("售出")]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn-action keep",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.resetItem(index)
                                                },
                                              },
                                            },
                                            [_vm._v("存背包")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isAutoConverted
                                    ? _c(
                                        "div",
                                        { staticClass: "happy-coin-msg" },
                                        [
                                          _vm._v(
                                            "已自动转为" +
                                              _vm._s(
                                                _vm.autoConvertCurrencyName
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                !_vm.isAutoConverted
                  ? _c("div", { staticClass: "pop-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-global sell-all",
                          on: {
                            click: function ($event) {
                              return _vm.case_opened_awards_discount(null)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.case_opened_awards.length > 1
                                  ? "全部售出"
                                  : "回收售出"
                              ) +
                              " "
                          ),
                          _c(
                            "span",
                            { staticClass: "total-amount" },
                            [
                              _vm._v(" ￥"),
                              _c("c-number", {
                                attrs: {
                                  duration: 1000,
                                  from: 0,
                                  to: _vm.case_opened_awards_amount,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn-global keep-all",
                          on: { click: _vm.reset },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.resetText == "存入背包"
                                  ? _vm.case_opened_awards.length > 1
                                    ? "批量存入背包"
                                    : "放入背包"
                                  : _vm.resetText
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _c("c-unpackgameInstance-item", {
        attrs: {
          type: "accumulate",
          muxiangCaseId: _vm.case_info.caseId,
          gameInstanceId: _vm.gameInstance_info.caseId,
        },
        on: { "on-unpackgameInstanceClose": _vm.onUnpackgameInstanceClose },
        model: {
          value: _vm.unpackgameInstance_item_show,
          callback: function ($$v) {
            _vm.unpackgameInstance_item_show = $$v
          },
          expression: "unpackgameInstance_item_show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }